import { Platform } from './index'
import { ShopifyPlatform } from './shopify'

export function detectPlatform(name?: string): Platform | undefined {
  const ctx = window as any
  let platform

  if (name === 'shopify' || ShopifyPlatform.detect(ctx)) {
    platform = new ShopifyPlatform()
  }

  if (platform) {
    console.info(`working on ${platform.name}`)
  }
  return platform
}
